import { environmentsEndPointsURLs } from '../configs/index'
import {
   enableBackendBaseUrlChange,
   getGraphQLBaseURL,
   getGraphQLSubscriptionURL,
   getLoginClientId,
   getRestBaseURL,
   setGraphQLBaseURL,
   setGraphQLSubscriptionURL,
   setLoginClientId,
   setRestBaseURL
} from './index'

const envVariables = process.env

const Config: any = {}

Object.keys(envVariables).forEach(variable => {
   if (variable.includes('NX')) {
      const envKey = variable.replace('NX_', '')
      Config[envKey] = envVariables[variable]
   }
})

if (enableBackendBaseUrlChange(Config)) {
   const loginClientId = getLoginClientId()

   const baseUrl = getRestBaseURL()
   const graphQLUrl = getGraphQLBaseURL()
   const graphQLSubscriptionUrl = getGraphQLSubscriptionURL()

   if (!loginClientId)
      setLoginClientId(environmentsEndPointsURLs[0].loginClientId)

   if (!baseUrl) setRestBaseURL(environmentsEndPointsURLs[0].URLs.restBaseURL)
   if (!graphQLUrl)
      setGraphQLBaseURL(environmentsEndPointsURLs[0].URLs.graphqlBaseURL)
   if (!graphQLSubscriptionUrl)
      setGraphQLSubscriptionURL(
         environmentsEndPointsURLs[0].URLs.graphqlSubscriptionURL
      )

   Config['LOGIN_CLIENT_ID'] = getLoginClientId()

   Config['BACKEND_REST_URL'] = getRestBaseURL()
   Config['BACKEND_GRAPHQL_URL'] = getGraphQLBaseURL()
   Config['BACKEND_GRAPHQL_SUBSCRIPTION_URL'] = getGraphQLSubscriptionURL()
}

export { Config }
